import { Dispatch } from 'redux';

import * as actionTypes from './actionTypes/companyTypes';
import { Http } from '../tools/http';
import { ICompany } from '../entities/ICompany';
import { getCompanyById } from './legalEntitiesActions';

export const getCompanyExpertises = (id: string) => ((dispatch, getState, http: Http) => {
    dispatch({ type: actionTypes.GET_COMPANY_EXPERTISES_REQUESTED });
    return http.apiGet(`/companies/${id}/expertises`)
        .then(expertises => {
            dispatch({
                type: actionTypes.GET_COMPANY_EXPERTISES_COMPLETED,
                expertises
            });

            return expertises;
        });
}) as any;

export const getCompany = (id: string) => ((dispatch, getState, http: Http) => {
    dispatch({ type: actionTypes.GET_COMPANY_REQUESTED });
    dispatch(getCompanyExpertises(id));
    return dispatch(getCompanyById(id))
        .then(company => {
            dispatch({
                type: actionTypes.GET_COMPANY_COMPLETED,
                company
            } as IGetCompany);

            return company;
        });
}) as any;

export const clearCompany = () => ({
    type: actionTypes.CLEAR_LOADED_COMPANY
});

export interface IGetCompany {
    type: string,
    company: ICompany
}

export interface IGetOrganization {
    type: string,
    organization: ICompany
}

export const getOrganization = (id: string): Promise<any> => ((dispatch, getState, http: Http) => {
    dispatch({ type: actionTypes.GET_ORGANIZATION_REQUESTED });
    return http.apiGet(`/organizations/${id}`)
        .then(organization => {
            dispatch({
                type: actionTypes.GET_ORGANIZATION_COMPLETED,
                organization
            } as IGetOrganization);

            return organization;
        });
}) as any;

export const clearOrganization = () => ({
    type: actionTypes.CLEAR_LOADED_ORGANIZATION
});

export const getOrganizationExpertises = (id: string) => ((dispatch, getState, http: Http) => {
    dispatch({ type: actionTypes.GET_ORGANIZATION_EXPERTISES_REQUESTED });
    return http.apiGet(`/organizations/${id}/expertises`)
        .then(expertises => {
            dispatch({
                type: actionTypes.GET_ORGANIZATION_EXPERTISES_COMPLETED,
                expertises
            });

            return expertises;
        });
}) as any;

export const getAllPublicOrganizations = () => ((dispatch, getState, http: Http) => {
    dispatch({ type: actionTypes.GET_PUBLIC_ORGANIZATION_REQUESTED });
    return http.apiGet(`/organizations`).then(response => {
        dispatch({
            type: actionTypes.GET_PUBLIC_ORGANIZATION_COMPLETED,
            publicOrganization: response || []
        });
    });
}) as any;

export const getFilteredOrganizations = (filter: string = '', amount: number = 10, lcid: number = 1033): Promise<ICompany[]> => ((dispatch: Dispatch, getState, http: Http) => {
    return http.apiGet(`/organizations/filtered?name=${(filter && filter.trim() !== '') && `${encodeURIComponent(filter)}`}&top=${amount}&lcid=${lcid}`);
}) as any;
